import type { IconNode } from '../types';

/**
 * @name rotate-cw-clock
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgN3Y1bDQgMiIgLz4KICA8cGF0aCBkPSJNMTYgOGg1VjMiIC8+CiAgPHBhdGggZD0ibTIxIDgtMi4zLTIuM0E5LjcgOS43IDAgMDAxMiAzYTkgOSAwIDEwOSA5IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/rotate-cw-clock
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const RotateCwClock: IconNode = [
  ['path', { d: 'M12 7v5l4 2' }],
  ['path', { d: 'M16 8h5V3' }],
  ['path', { d: 'm21 8-2.3-2.3A9.7 9.7 0 0012 3a9 9 0 109 9' }],
];

export default RotateCwClock;
